<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<form [formGroup]="usuarioForm" autocomplete="off">
			<div class="row">
				<div class="col-md-6 form-group">
					<i class="fas fa-id-card"></i>&nbsp;
					<label for="nombre">Nombre</label>
					<input formControlName="nombre" class="form-control" id="nombre" required>
					<span class="text-danger"
						*ngIf="(usuarioForm.get('nombre').touched) && usuarioForm.get('nombre').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-6">
					<i class="fas fa-id-badge"></i>&nbsp;
					<label for="apellidoPaterno">Apellido Paterno</label>
					<input formControlName="apellidoPaterno" class="form-control" id="apellidoPaterno" required>
					<span class="text-danger"
						*ngIf="(usuarioForm.get('apellidoPaterno').touched) && usuarioForm.get('apellidoPaterno').errors?.required">
						Campo requerido
					</span>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6">
					<i class="fas fa-id-badge"></i>&nbsp;
					<label for="apellidoMaterno">Apellido Materno</label>
					<input formControlName="apellidoMaterno" class="form-control" id="apellidoMaterno" required>
					<span class="text-danger"
						*ngIf="(usuarioForm.get('apellidoMaterno').touched) && usuarioForm.get('apellidoMaterno').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-6 form-group" *ngIf="!idUsuarioMod">
					<i class="fas fa-envelope"></i>&nbsp;
					<label id="correo">Correo</label>
					<input formControlName="correo" class="form-control" id="correo" required="required">
					<span class="text-danger"
						*ngIf="(usuarioForm.get('correo').touched) && usuarioForm.get('correo').errors?.required">
						Campo requerido
					</span>
					<span class="text-danger"
						*ngIf="(usuarioForm.get('correo').touched) && usuarioForm.get('correo').errors?.email">
						Campo requerido
					</span>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 form-group" *ngIf="!idUsuarioMod">
					<div formGroupName="passwordGroup">
						<i class="fas fa-key"></i>&nbsp;
						<label id="pws1">Contraseña</label>
						<input type="password" pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$"
							formControlName="password" required="required" class="form-control">
					</div>
					<span class="text-danger"
						*ngIf="(usuarioForm.get('passwordGroup').get('password').touched) && usuarioForm.get('passwordGroup').get('password').errors?.email">
						Campo requerido
					</span>
				</div>
				<div class="col-md-6" *ngIf="!idUsuarioMod">
					<div formGroupName="passwordGroup">
						<i class="fas fa-key"></i>&nbsp;
						<label id="matLabel">Confirmar Contraseña</label>
						<input matInput type="password" formControlName="confirmPassword" required="required"
							class="form-control">
					</div>
					<span class="text-danger"
						*ngIf="(usuarioForm.get('passwordGroup').get('confirmPassword').touched) && usuarioForm.get('passwordGroup').get('confirmPassword').errors?.email">
						Campo requerido
					</span>
				</div>
			</div>
			<div class="row">
				<div class="col-md-6 form-group" style="display: inline-block;">
					<i class="fas fa-calendar"></i>&nbsp;
					<label>Fecha Nacimiento</label>
					<dx-date-box formControlName="fechaNacimiento" type="datetime" [width]="400"
						displayFormat="yyyy-MM-dd" style="margin:0 auto;">
					</dx-date-box>
				</div>
					<div class="col-md-6 form-group">
						<i class="fas fa-user"></i>&nbsp;
						<label for="clientes">Tipo Usuario</label>
						<select id="clientes" formControlName="permisos" class="form-control">
							<option *ngFor="let cliente of listaTiposUsuario" [value]="cliente.id">{{cliente.nombre}}
							</option>
						</select>
					</div>
			</div>
			<div class="kt-portlet__foot">
				<div class="kt-form__actions kt-form__actions mt-3">
					<button mat-raised-button id="guardarBoton" (click)="onSubmit()" [disabled]=" loading">
						<i class="fa fa-save"></i>
						Guardar
						<span *ngIf="loading" class="kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light"
							style="padding-right: 15px; margin-left: 15px;"></span>
					</button>&nbsp;
					<button mat-raised-button (click)="onCancel()"><i class="fas fa-times"></i>&nbsp;Cancelar</button>
				</div>
			</div>
		</form>
	</div>
</div>